<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card :title="title" color="primary">
        <slot />
      </base-info-card>

      <template
        v-for="(
          { icon, text, title: t, link, untranslatedText }, i
        ) in business"
      >
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-if="text">{{ $t(text) }}</div>
          <div v-if="untranslatedText">{{ untranslatedText }}</div>
          <a
            v-if="link"
            v-bind:href="link"
            target="_blank"
            rel="noopener noreferrer"
            >{{ link }}</a
          >
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-github",
        title: "Github",
        text: "Check out the source code on GitHub_",
        link: "https://github.com/theMK2k/Media-Hoarder",
      },
      {
        icon: "mdi-forum",
        title: "Discuss",
        text: "Discuss the project (also on GitHub)_",
        link: "https://github.com/theMK2k/Media-Hoarder/discussions"
      },
      {
        icon: "mdi-mastodon",
        title: "Mastodon",
        text: "Say Hi! and follow me (MK2k) on Mastodon_",
        link: "https://mastodon.social/@MK2k",
      },
      {
        icon: "mdi-email",
        title: "Email",
        untranslatedText: "info [at] hoarder (dot) software",
      },
    ],
  }),
};
</script>
